import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import type { Content, ContentStack } from "pdfmake/interfaces";
import { QRCodeSVG } from "qrcode.react";
import ReactDOMServer from "react-dom/server";

(pdfMake as any).vfs = pdfFonts?.pdfMake?.vfs;

function getBase64Image(img: Blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

const RelatorioAnaliticoPdf = async (dados: any, imageDissolucao: any, imageTestePH: any, imageTesteVisual: any, imageTesteCromato: any) => {
    const today = new Date();
    const dia = today.getDate();
    const mes = today.toLocaleString("pt-BR", { month: "long" }).toUpperCase();
    const ano = today.getFullYear();

    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob)) as string;
    const imageConvert = await fetch("/img/logo/logoArmed.png").then((res) => res.blob());
    const imageArmed = (await getBase64Image(imageConvert)) as string;

    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/relatorio/${dados?._id}`}
            type="svg"
        />
    );

    function gerarTabela0(dados: any) {
        const amostra = dados;

        const linhas = [
            [{
                text: [
                    { text: `Nome do Medicamento: `, bold: true },
                    `${amostra?.producto?.nome}`
                ]
            }
            ],
            [{
                text: [
                    { text: `Substância activa: `, bold: true },
                    `${amostra?.substanciaActiva ?? ''}`
                ]
            }],
            [{
                text: [
                    { text: `Validade: `, bold: true },
                    `${new Date(amostra?.producto?.dataValidade).toLocaleDateString('pt-BR') ?? ''}`
                ]
            }],
            [{
                text: [
                    { text: `Lote: `, bold: true },
                    `${amostra?.producto?.lote}`
                ]
            }],
            [{
                text: [
                    { text: `Forma farmacêutica: `, bold: true },
                    `${amostra?.producto?.formaFarmaceutica}`
                ]
            }],
            [{
                text: [
                    { text: `Concentração: `, bold: true },
                    `${amostra?.concentracao}`
                ]
            }],
            [{
                text: [
                    { text: `Quantidade de amostras recebidas: `, bold: true },
                    `${amostra?.quantidadeAmostras ?? 'N/A'}`
                ]
            }],
            [{
                text: [
                    { text: `Nome do Laboratório: `, bold: true },
                    `${amostra?.localAnalise ?? 'N/A'}`
                ]
            }],
            [{
                text: [
                    { text: `Endereço do Fabricante: `, bold: true },
                    `${amostra?.producto?.enderecoFabricante}`
                ]
            }],
            [{
                text: [
                    { text: `Número de Registo da amostra: `, bold: true },
                    `${amostra?.numero}`
                ]
            }],
            [{
                text: [
                    { text: `Data de recepção da amostra: `, bold: true },
                    `${new Date(amostra?.dataEntregueAnalista).toLocaleDateString('pt-BR')}`
                ]
            }],
            [{
                text: [
                    { text: `Data de Execução de Ensaios: `, bold: true },
                    `${new Date(amostra?.dataEnsaios).toLocaleDateString('pt-BR') ?? ''}`
                ]
            }],
            [{
                text: [
                    { text: `Responsável pela amostra (requerente): `, bold: true },
                    `${amostra?.analista?.dadosPessoais?.nome}`
                ]
            }],
            [{
                text: [
                    { text: `Morada do requerente: `, bold: true },
                    `${amostra?.analista?.dadosPessoais?.municipio} - ${amostra?.analista?.dadosPessoais?.bairro}`
                ]
            }],
            [{
                text: [
                    { text: `Local da análise: `, bold: true },
                    `${amostra?.localAnalise}`
                ]
            }],
        ];

        const table = {
            headerRows: 1,
            widths: ['100%'],
            body: [
                [
                    {
                        text: 'Quadro Nº 1 - Dados da amostra',
                        fillColor: '#BDD6EE',
                        bold: true,
                        color: '#202020',
                        alignment: 'center',
                        fontSize: 8,
                        margin: [0, 5, 0, 5]
                    }
                ],
                ...linhas.map(linha => [
                    {
                        text: linha[0],
                        style: 'bodyTabela',
                        margin: [0, 3, 0, 5],
                    }
                ])
            ]
        };

        return table;
    }

    function gerarTabelaInspecaoAlternative(dados: any) {
        const amostra = dados;
        const table = {
            headerRows: 2,
            layout: {
                fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                    return rowIndex > 0 && columnIndex === 0 ? '#F2F2F2' : null;
                }
            },
            widths: ['21%', '47%', '12%', '20%'],
            body: [
                // Header row
                [
                    {
                        text: 'Quadro Nº 2 - Inspeção visual e física da amostra',
                        colSpan: 2,
                        fillColor: '#BDD6EE',
                        bold: true,
                        color: '#000',
                        alignment: 'center',
                        fontSize: 9,
                        margin: [0, 3]
                    },
                    {},
                    {
                        text: 'Resultado',
                        fillColor: '#BDD6EE',
                        bold: true,
                        color: '#000',
                        alignment: 'center',
                        fontSize: 9,
                        margin: [0, 3]
                    },
                    {
                        text: 'Referência Bibliográfica',
                        fillColor: '#BDD6EE',
                        bold: true,
                        color: '#000',
                        alignment: 'center',
                        fontSize: 9,
                        margin: [0, 3]
                    }
                ],
                [
                    { text: 'Nome do medicamento', bold: true, fontSize: 9, },
                    { text: `${amostra?.inspeccaoVisualFisica?.nome || ''}`, fontSize: 9, },
                    {
                        text: `${amostra?.inspeccaoVisualFisica?.resultado}`,
                        rowSpan: 8,
                        alignment: 'center',
                        bold: true,
                        fontSize: 9,
                    },
                    {
                        text: `${amostra?.inspeccaoVisualFisica?.referenciaBibliografica}`,
                        rowSpan: 8,
                        fontSize: 9,
                    }
                ],
                [{ text: 'Cor', bold: true, fontSize: 9, }, { text: `${amostra?.inspeccaoVisualFisica?.cor || ''}`, fontSize: 9 }, {}, {},],
                [{ text: 'Forma farmacêutica', bold: true, fontSize: 9, }, { text: `${amostra?.inspeccaoVisualFisica?.formaFarmaceutica || ''}`, fontSize: 9 }, {}, {}],
                [{ text: 'Tamanho e forma do comprimido', bold: true, fontSize: 9, }, { text: `${amostra?.inspeccaoVisualFisica?.tamanhoForma || ''}`, fontSize: 9 }, {}, {}],
                [{ text: 'Uniformidade da forma', bold: true, fontSize: 9, }, { text: `${amostra?.inspeccaoVisualFisica?.uniformidadeForma || ''}`, fontSize: 9 }, {}, {}],
                [{ text: 'Uniformidade da cor', bold: true, fontSize: 9, }, { text: `${amostra?.inspeccaoVisualFisica?.uniformidadeCor || ''}`, fontSize: 9 }, {}, {}],
                [{ text: 'Danos físicos', bold: true, fontSize: 9, }, { text: `${amostra?.inspeccaoVisualFisica?.danosFisicos || ''}`, fontSize: 9 }, {}, {}],
                [{ text: 'Outras observações', bold: true, fontSize: 9, }, { text: `${amostra?.inspeccaoVisualFisica?.outrasObservacoes || ''}`, fontSize: 9 }, {}, {}]
            ]
        };

        return table;
    }

    const linhasTabelaDissolucao = dados.testesDissolucao?.map((dissolucao: { padrao: any; amostra: any; resultado: any; }, index: number) => ([
        { text: `${index + 1}º Ensaio`, alignment: 'center', style: 'bodyTabela' },
        { text: dissolucao.padrao ?? '', alignment: 'center', style: 'bodyTabela' },
        { text: dissolucao.amostra ?? '', alignment: 'center', style: 'bodyTabela' },
        { text: dissolucao.resultado ?? '', alignment: 'center', style: 'bodyTabela' }
    ]));


    function gerarTabelaDissolucao(dados: any) {
        const amostra = dados;
        const table = {
            headerRows: 2,
            layout: {
                fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                    return null;
                }
            },
            widths: ['20%', '30%', '30%', '20%'],
            body: [
                [
                    {
                        text: 'Quadro Nº 3 - Teste de dissolução',
                        colSpan: 4,
                        fillColor: '#BDD6EE',
                        alignment: 'center',
                        bold: true,
                        fontSize: 9,
                        margin: [0, 5]
                    }, {}, {}, {}
                ],
                [
                    { text: 'Ensaio', fillColor: '#D9D9D9', bold: true, alignment: 'center', rowSpan: 2, style: 'bodyTabela', },
                    { text: 'Tempo', fillColor: '#D9D9D9', colSpan: 2, bold: true, alignment: 'center', style: 'bodyTabela' }, {},
                    { text: 'Resultado', fillColor: '#D9D9D9', bold: true, alignment: 'center', style: 'bodyTabela', rowSpan: 2, }
                ],
                [
                    '',
                    { text: 'Padrão', fillColor: '#F2F2F2', alignment: 'center', style: 'bodyTabela' },
                    { text: 'Amostra', fillColor: '#F2F2F2', alignment: 'center', style: 'bodyTabela' },
                    ''
                ],
                ...linhasTabelaDissolucao,
            ]
        };
        return table;
    }

    function gerarTabelaCromatpgrafia(dados: any) {
        const amostra = dados;
        const table = {
            headerRows: 2,
            layout: {
                fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                    return null;
                }
            },
            widths: ['10%', '20%', '20%', '20%', '20%', '10%'],

            body: [
                [
                    {
                        text: 'Quadro Nº 4 - Cromatografia em camada delgada',
                        colSpan: 5,
                        fillColor: '#BDD6EE',
                        alignment: 'center',
                        bold: true,
                        fontSize: 9,
                        margin: [0, 5]
                    },
                    {},
                    {},
                    {},
                    {},
                    {
                        text: 'Método',
                        fillColor: '#BDD6EE',
                        alignment: 'center',
                        bold: true,
                        fontSize: 9,
                        margin: [0, 5]
                    }
                ],
                [
                    {
                        text: 'Amostra',
                        fillColor: '#D9D9D9',
                        bold: true,
                        alignment: 'center',
                        rowSpan: 2,
                        fontSize: 8
                    },
                    {
                        text: 'Intensidade da mancha da amostra',
                        fillColor: '#D9D9D9',
                        colSpan: 3,
                        bold: true,
                        alignment: 'center',
                        fontSize: 8
                    },
                    {},
                    {},
                    {
                        text: 'Resultado',
                        fillColor: '#D9D9D9',
                        bold: true,
                        alignment: 'center',
                        rowSpan: 2,
                        fontSize: 8
                    },
                    {
                        text: `${amostra.cromatografia.metodo}`,
                        bold: true,
                        alignment: 'center',
                        rowSpan: 3,
                        fontSize: 8
                    }
                ],
                [
                    {},
                    {
                        text: '<=80%',
                        fillColor: '#F2F2F2',
                        alignment: 'center',
                        fontSize: 8
                    },
                    {
                        text: '80-100%',
                        fillColor: '#F2F2F2',
                        alignment: 'center',
                        fontSize: 8
                    },
                    {
                        text: '>=100%',
                        fillColor: '#F2F2F2',
                        alignment: 'center',
                        fontSize: 8
                    },
                    {},
                    {}
                ],

                [
                    {
                        text: `${amostra?.producto?.nome}`,
                        alignment: 'center',
                        fontSize: 9,
                        bold: true
                    },
                    {
                        text: amostra?.cromatografia?.intesidadeMancha <= 80 ? 'X' : `${amostra?.cromatografia?.intesidadeMancha}`,
                        alignment: 'center',
                        fontSize: 9
                    },
                    {
                        text: amostra?.cromatografia?.intesidadeMancha === 81 && amostra?.cromatografia?.intesidadeMancha <= 100 ? 'X' : `${amostra?.cromatografia?.intesidadeMancha}`,
                        alignment: 'center',
                        fontSize: 9
                    },
                    {
                        text: amostra?.cromatografia?.intesidadeMancha >= 101 ? 'X' : `${amostra?.cromatografia?.intesidadeMancha}`,
                        alignment: 'center',
                        fontSize: 9,
                        bold: true
                    },
                    {
                        text: amostra?.cromatografia?.resultado || '',
                        alignment: 'center',
                        fontSize: 9,
                        bold: true,
                        color: '#2E7D32'
                    },
                    {

                    }
                ]
            ]
        };
        return table;
    }

    const linhasTabelaPh = dados?.testesPH?.map((item: { amostra: any; resultado: any; referencia: any; }) => ([
        { text: item.amostra ?? '', alignment: 'center', style: 'bodyTabela' },
        { text: item.resultado ?? '', alignment: 'center', style: 'bodyTabela' },
        { text: item.referencia ?? '', alignment: 'center', style: 'bodyTabela' }
    ]));

    function gerarTabelaPH(dados: any) {
        const amostra = dados;
        const table = {
            headerRows: 2,
            layout: {
                fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                    return null;
                }
            },
            widths: ['*', '*', '*'],
            body: [
                [
                    {
                        text: 'Quadro Nº 5 - Teste de PH',
                        colSpan: 3,
                        fillColor: '#BDD6EE',
                        alignment: 'center',
                        bold: true,
                        fontSize: 9,
                        margin: [0, 5]
                    }, {}, {},
                ],
                [
                    { text: 'Amostra', fillColor: '#D9D9D9', bold: true, alignment: 'center', rowSpan: 1, style: 'bodyTabela', },
                    { text: 'Resultado', fillColor: '#D9D9D9', colSpan: 1, bold: true, alignment: 'center', style: 'bodyTabela' },
                    { text: 'Referência', fillColor: '#D9D9D9', bold: true, alignment: 'center', style: 'bodyTabela', rowSpan: 1, }
                ],

                ...linhasTabelaPh,
            ]
        };
        return table;
    }

    const colunasPorLinha = 3;
    const imagensEmLinhas = [];
    if (imageTesteVisual.length > 0) {
        for (let i = 0; i < imageTesteVisual.length; i += colunasPorLinha) {
            const linha = imageTesteVisual.slice(i, i + colunasPorLinha).map((img: string) => ({
                image: img,
                width: 135,
                height: 135,
                margin: [5, 5, 5, 5]
            }));
            imagensEmLinhas.push(linha);
        }
    }


    const imagensEmLinhasDissolu = [];
    if (imageDissolucao.length > 0) {
        for (let i = 0; i < imageDissolucao.length; i += colunasPorLinha) {
            const linha = imageDissolucao.slice(i, i + colunasPorLinha).map((img: string) => ({
                image: img,
                width: 135,
                height: 135,
                margin: [5, 5, 5, 5]
            }));
            imagensEmLinhasDissolu.push(linha);
        }
    }

    const imagensEmLinhasCromagro = [];
    if (imageTesteCromato.length > 0) {
        for (let i = 0; i < imageTesteCromato.length; i += colunasPorLinha) {
            const linha = imageTesteCromato.slice(i, i + colunasPorLinha).map((img: string) => ({
                image: img,
                width: 135,
                height: 135,
                margin: [5, 5, 5, 5]
            }));
            imagensEmLinhasCromagro.push(linha);
        }
    }

    const imagensEmLinhasPh = [];
    if (imageTestePH.length > 0) {
        for (let i = 0; i < imageTestePH.length; i += colunasPorLinha) {
            const linha = imageTestePH.slice(i, i + colunasPorLinha).map((img: string) => ({
                image: img,
                width: 135,
                height: 135,
                margin: [5, 5, 5, 5]
            }));
            imagensEmLinhasPh.push(linha);
        }
    }

    const docDefinition: TDocumentDefinitions = {
        pageSize: "A4",
        pageMargins: [45, 40, 45, 80],

        content: [
            {
                columns: [
                    {
                        //width: "30%",
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                        ],
                        alignment: "left",
                        style: "header",
                    },
                    {
                        image: imageBase64 as string,
                        width: 80,
                        height: 80,
                        alignment: "center",
                    },
                    {
                        text: "",
                        width: "43%",
                    },

                ],
                margin: [0, 0, 0, 2],
            },
            // {
            //     image: imageBase64 as string,
            //     width: 80,
            //     height: 80,
            //     alignment: "center",
            // },
            { text: "REPÚBLICA DE ANGOLA", style: "header" },
            { text: "MINISTÉRIO DA SAÚDE", style: "header" },
            {
                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                style: "header",
            },
            {
                text: "DEPARTAMENTO DE CONTROLO DE QUALIDADE DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                style: "header",
            },
            {
                text: `RELATÓRIO ANALÍTICO DO MEDICAMENTO ${dados?.producto.nome.toUpperCase()}`,
                style: "header",
                margin: [0, 10, 0, 10],
            },
            {
                text: [
                    { text: `No dia ${new Date(dados?.createdAt).toLocaleDateString('pt-BR')}, `, bold: true },
                    `realizou-se a análise laboratorial do produto`,
                    { text: `${dados?.producto?.nome}`, bold: true },
                    ` no(a) ${dados?.localAnalise}, obtendo os resultados descrito abaixo: `,
                ],
                style: "body",
                margin: [0, 30, 0, 5],
            },
            { table: gerarTabela0(dados) },
            { text: '', pageBreak: 'after' },
            {
                text: [
                    `Procedeu-se a inspecção visual e física do medicamento `,
                    { text: `${dados?.producto.nome ?? ""}`, bold: true },
                    `, conforme espelha o quandro Nº 2: `,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            { table: gerarTabelaInspecaoAlternative(dados) },
            // { text: '', pageBreak: 'after' },
            {
                table: {
                    widths: Array(colunasPorLinha).fill('*'),
                    body: imagensEmLinhas.length > 0 ? imagensEmLinhas : [[]]
                },
                layout: 'noBorders',
                margin: [0, 10, 0, 10],
                alignment: 'center'
            },

            {
                text: [
                    `Realizou - se teste de dissolução para verificar a propriedade física-química do medicamento em causa, a uma temperatura de `,
                    { text: `${dados?.temperatura}` },
                    `, como espelha o Quandro nº 3: `,
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 10, 0, 10],
            },

            { table: gerarTabelaDissolucao(dados) },
            {
                text: [
                    `A amostra dissolveu dentro do tempo como recomendado pleo manual GPHF, Vide imagens abaixo:`,
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 10, 0, 10],
            },
            {
                table: {
                    widths: Array(colunasPorLinha).fill('*'),
                    body: imagensEmLinhasDissolu.length > 0 ? imagensEmLinhasDissolu : [[]]
                },
                layout: 'noBorders',
                margin: [0, 10, 0, 10],
                alignment: 'center'
            },
            // { text: '', pageBreak: 'after' },
            {
                text: [
                    `Para a identificação e quantificação da substância foi utilizada a técnica cromatográfica líquida-sólida. Os resultados encontram - se espelhados no quadro nº 4:`,
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 10, 0, 10],
            },
            { table: gerarTabelaCromatpgrafia(dados) },

            {
                text: [
                    `Após a realização da técnica cromatográfica líquida-sólida, obteve-se os seguintes resultados de Factor de Retenção `,
                    { text: `(R`, bold: true },
                    { text: `f)`, italics: true, bold: true },
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 10, 0, 10],
            },
            {
                text: [
                    { text: `R`, bold: true },
                    { text: `f`, italics: true, bold: true },
                    { text: `Padrão/Para`, fontSize: 7 },
                    { text: `=` },
                    { text: ``, bold: true },
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 3, 0, 0],
            },
            {
                text: [
                    { text: `R`, bold: true },
                    { text: `f`, italics: true, bold: true },
                    { text: `Padrão/Para`, fontSize: 7 },
                    { text: `=` },
                    { text: ``, bold: true },
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 3, 0, 0],
            },
            {
                text: [
                    `A intensidade da mancha da amostra comparada com o padrão apresentou a mesma percentagem na substância activa nomeadamente: `,
                    { text: `${dados?.producto.nome ?? ""},` },
                    ` considerado assim, que o princípio activo da mesma está dentro dos limites de concentração, conforme placas a baixo: `
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 10, 0, 10],
            },
            {
                table: {
                    widths: Array(colunasPorLinha).fill('*'),
                    body: imagensEmLinhasCromagro.length > 0 ? imagensEmLinhasCromagro : [[]]
                },
                layout: 'noBorders',
                margin: [0, 10, 0, 10],
                alignment: 'center'
            },
            { text: '', pageBreak: 'after' },
            { table: gerarTabelaPH(dados), margin: [0, 15, 0, 10], },
            {
                table: {
                    widths: Array(colunasPorLinha).fill('*'),
                    body: imagensEmLinhasPh.length > 0 ? imagensEmLinhasPh : [[]]
                },
                layout: 'noBorders',
                margin: [0, 10, 0, 10],
                alignment: 'center'
            },
            {
                text: 'COMENTÁRIOS E CONCLUSÕES',
                alignment: "center",
                style: "body",
                bold: true,
                fontSize: 11,
                margin: [0, 40, 0, 0],
            },

            {
                text: `Após análise do  medicamento ${dados?.producto.nome ?? "-"}, verificou-se que: `,
                alignment: "justify",
                style: "body",
                margin: [0, 5, 0, 10],
            },
            {
                text: [
                    { text: 'Comentário final: ', bold: true, fontSize: 12 },
                    `${dados?.comentariosConclusoes}`
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 10, 0, 10],
            },
            {
                text: `DEPARTAMENTO DE CONTROLO DE QUALIDADE DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE, EM LUANDA, AOS ${dia} DE ${mes} DE ${ano}.`,
                alignment: "justify",
                bold: true,
                fontSize: 11,
                margin: [0, 30, 0, 0],
            },
            {
                columns: [
                    {
                        width: '*',
                        stack: [
                            {
                                text: "Analizado Por",
                                alignment: "center",
                                style: "signature",
                                margin: [0, 50, 0, 10],
                            },
                            {
                                text: `${dados?.analista?.dadosPessoais?.nome}`,
                                alignment: "center",
                                style: "body",
                            }
                        ]
                    },
                    {
                        width: '*',
                        stack: [
                            {
                                text: "Aprovado Por",
                                alignment: "center",
                                style: "signature",
                                margin: [0, 50, 0, 10],
                            },
                            {
                                text: `${dados?.revisor?.dadosPessoais?.nome}`,
                                alignment: "center",
                                style: "body",
                            }
                        ]
                    }
                ]
            },

        ],

        footer: () => {
            return [
                {
                    text: "____________________________________________________________________________________________________",
                    style: "",
                    margin: [0, 0, 0, 0],
                    bold: true,
                    alignment: "center",
                },
                {
                    columns: [
                        {
                            stack: [
                                {
                                    text: "Rua Cmdt. Che Guevara nº 6/86º Bº Maculusso, Ingombota",
                                    style: "",
                                    margin: [0, 10, 0, 0],
                                    bold: true,
                                },
                                {
                                    text: "Tel.: +244 938 120 372",
                                    style: "",
                                    margin: [0, 0, 0, 0],
                                    bold: true,
                                },
                                {
                                    text: "Email: geral@armed.minsa.gov.ao LUANDA-ANGOLA",
                                    style: "",
                                    margin: [0, 0, 0, 0],
                                    bold: true,
                                },
                            ],
                            width: "70%",
                            fontSize: 9,
                            alignment: "left",
                        },
                        {
                            width: "30%",

                            stack: [
                                {
                                    image: imageArmed as string,
                                    width: 100,
                                    height: 40,
                                    alignment: "center" as "center",
                                },
                            ],
                        },
                    ],
                    alignment: "center",
                    fontSize: 8,
                    margin: [50, 0, 50, 0],
                },
            ];
        },


        images: {
            mySuperImage: `data:image/jpeg;base64,/${imageBase64}`,
            // in browser is supported loading images via url (https or http protocol) (minimal version: 0.1.67)
            snow: "/img/logo/logoArmed.png",
            // is supported loading images via url with custom headers (minimal version: 0.2.5)
            strawberries: {
                url: "/img/logo/logoArmed.png",
                headers: {
                    myheader: "123",
                    myotherheader: "abc",
                },
            },
        } as Record<string, any>,

        styles: {
            header: {
                fontSize: 10,
                bold: true,
                alignment: "center",
                margin: [0, 0, 0, 0],
            },
            subheader: {
                fontSize: 10,
                bold: true,
                alignment: "center",
                margin: [0, 0, 0, 0],
                decoration: "underline",
            },
            declaration: {
                fontSize: 10,
                bold: true,
                alignment: "center",
                margin: [0, 0, 0, 0],
                decoration: "underline",
            },
            body: {
                fontSize: 10,
                alignment: "justify",
                margin: [0, 0, 0, 10],
                lineHeight: 1.3,
            },
            bodyTabela: {
                fontSize: 9,
                alignment: "justify",
                margin: [0, 0, 0, 5],
                lineHeight: 0.5,
            },
            signature: {
                fontSize: 10,
                decoration: 'underline',
                bold: true,
                margin: [0, 10, 0, 0],
            },
        },
        defaultStyle: {
            font: "Roboto",
        },
    };

    pdfMake.createPdf(docDefinition).open();
}

export default RelatorioAnaliticoPdf
